import { SimulationRunOptions } from './types';

const DEFAULT_YIELD_INTERVAL = 250;

export class SimulationAbortedError extends Error {
    constructor() {
        super('Simulation cancelled.');
        this.name = 'AbortError';
    }
}

export function isSimulationAbortedError(error: unknown): error is Error {
    return error instanceof Error && error.name === 'AbortError';
}

export function throwIfSimulationAborted(signal?: AbortSignal): void {
    if (signal?.aborted) {
        throw new SimulationAbortedError();
    }
}

export function maybeYieldForSimulationChunk(
    completedSteps: number,
    options: SimulationRunOptions = {},
    yieldInterval = DEFAULT_YIELD_INTERVAL,
): Promise<void> | undefined {
    if (completedSteps === 0 || completedSteps % yieldInterval !== 0) {
        return undefined;
    }

    throwIfSimulationAborted(options.signal);
    return new Promise<void>((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            options.signal?.removeEventListener('abort', handleAbort);
            try {
                throwIfSimulationAborted(options.signal);
                resolve();
            } catch (error) {
                reject(error);
            }
        }, 0);

        const handleAbort = () => {
            clearTimeout(timeoutId);
            options.signal?.removeEventListener('abort', handleAbort);
            reject(new SimulationAbortedError());
        };

        options.signal?.addEventListener('abort', handleAbort, { once: true });
    });
}
